import ApeironLinearProgress from '@src/components/share/apeiron/ApeironLinearProgress'
import { DATE_DISPLAY_FORMAT } from '@src/constants/date'
import { differenceInSeconds, format } from 'date-fns'
import { FC } from 'react'

const getFormatDateString = (date: Date | string) => {
  return format(
    date instanceof Date ? date : new Date(date),
    DATE_DISPLAY_FORMAT
  )
}

const diffStringDate = (left: Date | string, right: Date | string) => {
  const leftDate = left instanceof Date ? left : new Date(left)

  const rightDate = right instanceof Date ? right : new Date(right)

  return differenceInSeconds(leftDate, rightDate)
}

const DateLinearProgress: FC<Props> = (props: Props) => {
  const { className, startAt, endAt, now } = props

  const durationTimeFromStartToNow = diffStringDate(now, startAt)

  const durationTimeFromStartToEnd = diffStringDate(endAt, startAt)

  const processPercent = Math.max(
    5, // show the minimum progress bar
    Math.min(
      100,
      (durationTimeFromStartToNow / durationTimeFromStartToEnd) * 100
    )
  )

  return (
    <ApeironLinearProgress
      className={className}
      end={getFormatDateString(endAt)}
      start={getFormatDateString(startAt)}
      percent={processPercent}
    />
  )
}

type Props = {
  className?: string
  endAt: Date
  now: Date
  startAt: Date
}

export default DateLinearProgress
